var __jsx = React.createElement;
import DixuMainFooter from "../DixuMainFooter/DixuMainFooter";
import DixuMainNav from "../DixuMainNav/DixuMainNav";
import React from 'react';
const DixuSiteFrame = _ref => {
  let {
    hideMainNav,
    hideMainFooter,
    mainNavProps,
    mainFooterProps,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "dixu-site-frame"
  }, !hideMainNav && /*#__PURE__*/React.createElement(DixuMainNav, mainNavProps), /*#__PURE__*/React.createElement("main", {
    className: "dixu-site-frame__main-content"
  }, children), !hideMainFooter && /*#__PURE__*/React.createElement(DixuMainFooter, mainFooterProps));
};
DixuSiteFrame.defaultProps = {
  hideMainNav: false,
  hideMainFooter: false,
  mainNavProps: undefined,
  mainFooterProps: undefined
};
export default DixuSiteFrame;